import { render, staticRenderFns } from "./tyyLiveAppointmentLists.vue?vue&type=template&id=4fadc48c&"
import script from "./tyyLiveAppointmentLists.vue?vue&type=script&lang=js&"
export * from "./tyyLiveAppointmentLists.vue?vue&type=script&lang=js&"
import style0 from "./tyyLiveAppointmentLists.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports